/**
 * Preciznija pretraga.
 *
 * Shopify podrazumevano traži BILO KOJU reč iz upita, ne sve. Zato je "patosnice
 * za auto" vraćalo 993 rezultata: reč "za" sama pogađa 1002 proizvoda, "auto"
 * isto toliko, pa je zbir praktično ceo katalog. Izmereno, nije procena.
 *
 * Dva koraka:
 *   1) Izbace se reči koje ne sužavaju ništa ("za", "auto", predlozi). U ovoj
 *      prodavnici je baš "auto" bezvredan za pretragu — svaki proizvod je za auto.
 *   2) Od preostalih reči se sklopi upit koji traži SVE, po nazivu, tagu i tipu:
 *      (title:rucica OR tag:rucica OR product_type:rucica) AND (title:volkswagen OR ...)
 *      "rucica volkswagen" tako pada sa 647 na 40 pogodaka.
 *
 * Zašto i propadanje unazad: strogo traženje se lomi na srpskom. "brisaci" ne
 * pogađa "BRISAČ" (diakritika), "astru" ne pogađa "Astra" (padež), a "Golf" kod
 * patosnica živi u varijanti a ne u nazivu — u 3 od 12 probanih upita strogo je
 * vratilo nulu. Zato: ako strogo ne nađe ništa, stranica se sama ponovo učita
 * šire. Time nikad nije gore nego pre, a najčešće je bitno bolje.
 *
 * `qd` nosi ono što je kupac stvarno ukucao, da mu se u polju i naslovu ne
 * prikaže sklopljeni upit. `sq` nosi širu verziju za propadanje unazad.
 */
(function () {
  // Reči koje same pogađaju skoro ceo katalog, pa upit ne sužavaju nego ga šire.
  var PRAZNE = [
    'za', 'i', 'od', 'sa', 's', 'na', 'u', 'do', 'po', 'uz', 'iz', 'kod', 'te', 'ili',
    'auto', 'automobil', 'automobila', 'auta', 'autu', 'kola', 'vozilo', 'vozila'
  ];
  var POLJA = ['title', 'tag', 'product_type'];

  function reci(tekst) {
    return tekst
      .toLowerCase()
      .split(/[\s,;]+/)
      .map(function (r) { return r.replace(/[^\wčćžšđČĆŽŠĐ\-]/g, ''); })
      .filter(function (r) { return r && PRAZNE.indexOf(r) === -1; });
  }

  function strogiUpit(lista) {
    return lista
      .map(function (r) {
        return '(' + POLJA.map(function (p) { return p + ':' + r; }).join(' OR ') + ')';
      })
      .join(' AND ');
  }

  // Kupac koji sam kuca naprednu sintaksu zna šta radi — ne diramo mu upit.
  function vecNapredno(tekst) {
    return /:|\bAND\b|\bOR\b|"/.test(tekst);
  }

  function prepisi(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    var polje = form.querySelector('input[name="q"]');
    if (!polje) return;
    var uneto = (polje.value || '').trim();
    if (!uneto || vecNapredno(uneto)) return;

    var lista = reci(uneto);
    // Sve reči su bile prazne (npr. samo "za auto") — pusti original, bolje išta nego ništa.
    if (!lista.length) return;

    e.preventDefault();
    var p = new URLSearchParams();
    p.set('q', lista.length > 1 ? strogiUpit(lista) : lista[0]);
    p.set('qd', uneto);
    if (lista.length > 1) p.set('sq', lista.join(' '));
    p.set('options[prefix]', 'last');
    window.location.href = '/search?' + p.toString();
  }

  document.addEventListener('submit', prepisi, true);

  // ── Na stranici rezultata ────────────────────────────────────────────────
  var par = new URLSearchParams(window.location.search);
  var qd = par.get('qd');
  var sq = par.get('sq');

  function naStranici() {
    if (qd) {
      document.querySelectorAll('input[name="q"]').forEach(function (el) {
        if (el.value !== qd) el.value = qd;
      });
    }
    if (!sq) return;
    // Strogo nije našlo ništa (diakritika, padež, reč iz varijante) — ponovi šire.
    // `sq` se namerno ne prosleđuje dalje, da se ne vrtimo u krug.
    var imaRezultata = document.querySelector('.grid.product-grid .grid__item, .card-wrapper');
    if (imaRezultata) return;
    var p = new URLSearchParams();
    p.set('q', sq);
    if (qd) p.set('qd', qd);
    p.set('sire', '1');
    p.set('options[prefix]', 'last');
    window.location.replace('/search?' + p.toString());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', naStranici);
  } else {
    naStranici();
  }
})();
